import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const DealerLicense = () => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", p: "8px 8px 8px 24px" }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="Scanning"
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="Scanning"
            control={<Radio />}
            label="Scanning"
            checked={true}
            disabled={true}
          />
        </RadioGroup>
      </Box>
    </Box>
  );
};

export default DealerLicense;
